import { ref } from '@vue/composition-api';
import cloneDeep from 'lodash.clonedeep';
import { Wormhole } from 'portal-vue';

export default (props, context) => {
  const typeEdit = ref('');
  const logsList = ref({});
  const fieldName = ref('');
  const fieldValue = ref('');
  const currentShow = ref('entity');
  const showPopup = ref(false);
  const dropdownRights = ref([]);
  const popupValue = ref('');
  const action = ref('');
  const isShowNestedEntity = ref(false);
  const nestedEntity = ref(null);
  const currentAction = ref('');
  const typeAction = ref('');
  const currentContext = ref(null);
  const entityId = ref('');
  const popupLoading = ref(false);
  const targetObject = ref(null);

  const showNestedEntity = () => {
    isShowNestedEntity.value = true;
    currentShow.value = 'nestedEntity';
  };

  const checkRights = () => {
    return currentContext.value.raw.type;
  };

  const closeNestedCard = () => {
    // TODO: need rewrite
    // context.root.$router.go(-1);
    Wormhole.close({
      to: 'user-portal',
      from: 'user'
    });
    Wormhole.close({
      to: 'nested',
      from: 'object'
    });
    let q = cloneDeep(context.root.$route.query);
    if (q.nestedId) {
      delete q.nestedId;
      context.root.$router.push({
        query: q
      });
    }
  };

  const showFullNotices = () => {
    logsList.value = {};
    currentShow.value = 'full';
  };

  const showFullLogs = () => {
    currentShow.value = 'full';
  };

  const copyText = e => {
    context.root.$copyText(e).catch(err => {
      console.error(`Cannot copy: ${err}`);
    });
  };

  const handleClose = () => {
    typeAction.value = '';
    currentContext.value = null;
    popupValue.value = '';
    showPopup.value = false;
    dropdownRights.value = [];
  };

  const handleAction = e => {
    if (e.handleAction) {
      e.handleAction();
      return;
    }
    entityId.value = e.id;
    let name = e.actionName?.id || e.name?.id || e.actionName || e.name;
    let targetObjectFromContext =
      e?.actionName?.raw?.targetObject || e?.ctxItemRaw?.targetObject;
    if (targetObjectFromContext) {
      targetObject.value = targetObjectFromContext;
    }
    handleClose();
    switch (name) {
      case 'edit-rights':
        typeAction.value = 'edit-rights';
        currentContext.value = e?.context;
        showPopup.value = true;
        break;
      case 'change-password':
        typeAction.value = 'change-password';
        currentContext.value = e?.context;
        showPopup.value = true;
        break;
      case 'edit-field':
        action.value = 'editField';
        typeEdit.value = '';
        fieldName.value = e.context.subtitle;
        fieldValue.value = '';
        showPopup.value = true;
        break;
      case 'edit-variable':
        action.value = 'editField';
        typeEdit.value = 'variable';
        fieldName.value = e.context.subtitle;
        fieldValue.value = {
          value: '',
          name: ''
        };
        showPopup.value = true;
        break;
      case 'copy':
        copyText(e.context.title);
        break;
      case 'edit-control-scheme':
        showPopup.value = true;
        typeAction.value = 'edit-control-scheme';
        currentContext.value = e?.context?.raw;
        break;
      case 'controls-parameters-change':
        typeAction.value = 'controls-parameters-change';
        currentContext.value = e?.context?.raw;
        currentShow.value = 'controls-parameters-change';
        break;
      case 'edit-schema-property':
        showPopup.value = true;
        typeAction.value = 'edit-schema-property';
        currentContext.value = e?.context?.raw;
        break;
      case 'show-info-schema-property':
        showPopup.value = true;
        typeAction.value = 'show-info-schema-property';
        currentContext.value = e?.context?.raw;
        break;
      case 'add-object':
        typeAction.value = 'add-object';
        showPopup.value = true;
        break;
      case 'add-profile':
        typeAction.value = 'add-profile';
        showPopup.value = true;
        break;
      case 'edit-property':
        currentContext.value = e?.context;
        typeAction.value = 'edit-property';
        showPopup.value = true;
        break;
      case 'show-noty-by-object':
        currentContext.value = e;
        typeAction.value = 'show-noty-by-object';
        showFullLogs();
        break;
      case 'delete-schema-property':
        currentContext.value = e?.context;
        typeAction.value = 'delete-schema-property';
        showPopup.value = true;
        break;
      case 'massive-editgroup':
        typeAction.value = 'massive-editgroup';
        currentContext.value = e.ctxItemRaw.raw;
        showPopup.value = true;
        break;
      case 'edit':
        action.value = 'edit';
        showPopup.value = true;
        break;
      case 'send-noty':
        typeAction.value = 'send-noty';
        showPopup.value = true;
        break;
      case 'detail-notification':
        showPopup.value = true;
        typeAction.value = 'detail-notification';
        currentContext.value = e?.context?.raw;
        break;
      case 'enable-disable':
        typeAction.value = 'enable-disable';
        break;
      case 'mute-unmute':
        typeAction.value = 'mute-unmute';
        break;
      case 'change-user-group':
        showPopup.value = true;
        typeAction.value = 'change-user-group';
        break;
      case 'delete':
        showPopup.value = true;
        typeAction.value = 'delete';
        break;
      case 'remove':
        showPopup.value = true;
        currentContext.value = e.context.connectionId;
        typeAction.value = 'remove';
        break;
      case 'download-file':
        typeAction.value = 'download-file';
        break;
      case 'add-schema-control':
        showPopup.value = true;
        typeAction.value = 'add-schema-control';
        break;
      case 'add-schema-property':
        showPopup.value = true;
        currentContext.value = e?.raw;
        typeAction.value = 'add-schema-property';
        break;
      case 'copy-uuid':
        copyText(entityId.value);
        break;
      case 'export-json':
        typeAction.value = 'export-json';
        break;
      case 'bump-version':
        typeAction.value = 'bump-version';
        break;
      case 'edit-scheme':
        showPopup.value = true;
        typeAction.value = 'edit-scheme';
        break;
      case 'edit-device':
        showPopup.value = true;
        typeAction.value = 'edit-device';
        break;
      case 'edit-dataset':
        showPopup.value = true;
        typeAction.value = 'edit-dataset';
        break;
      case 'edit-media':
        showPopup.value = true;
        typeAction.value = 'edit-media';
        break;
      case 'change-scheme':
        showPopup.value = true;
        typeAction.value = 'change-scheme';
        break;
      case 'edit-user':
        showPopup.value = true;
        typeAction.value = 'edit-user';
        break;
      case 'show-history':
        currentContext.value = e?.context;
        typeAction.value = 'controls-history';
        showFullLogs();
        break;
      case 'show-property-history':
        currentContext.value = e?.context;
        typeAction.value = 'property-history';
        showFullLogs();
        break;
      case 'execute-control':
        currentContext.value = e?.context;
        showPopup.value = true;
        typeAction.value = 'execute-control';
        break;
      case 'change-group-access':
        currentContext.value = e?.context;
        showPopup.value = true;
        typeAction.value = 'change-group-access';
        break;
      case 'duplicate-schema':
        currentContext.value = e?.context;
        showPopup.value = true;
        typeAction.value = 'duplicate-schema';
        break;
      case 'set-property-default':
        currentContext.value = e?.context;
        showPopup.value = true;
        typeAction.value = 'set-property-default';
        break;
      case 'set-property-null':
        currentContext.value = e?.context;
        showPopup.value = true;
        typeAction.value = 'set-property-null';
        break;
      case 'apply-default-value':
        currentContext.value = e?.context;
        showPopup.value = true;
        typeAction.value = 'apply-default-value';
        break;
    }
  };

  const createIcon = (name, color = '', bg = '') => {
    return {
      name,
      color,
      bg
    };
  };

  return {
    handleAction,
    showFullLogs,
    showFullNotices,
    createIcon,
    showNestedEntity,
    closeNestedCard,
    nestedEntity,
    isShowNestedEntity,
    fieldValue,
    fieldName,
    dropdownRights,
    typeEdit,
    logsList,
    action,
    showPopup,
    currentShow,
    currentAction,
    currentContext,
    typeAction,
    checkRights,
    popupValue,
    handleClose,
    entityId,
    popupLoading,
    targetObject
  };
};
